enum BuildingClassEnum {
  ClassA = 'Class A',
  ClassB = 'Class B',
  ClassC = 'Class C',
}

export default BuildingClassEnum;
